import { t } from '../../i18n/index.js';
import { escapeHtml } from '../../utils/dom.js';
import { authShell, bindLangSelect } from './authShell.js';

// An unavailable session check is not a logged-out session. Retry only after a
// user action, respecting the server cooldown, without reloading the document.
export function showSessionRecovery(container, error, retry) {
  const delay = error.status === 429 ? (error.retryAfterMs ?? 60_000) : 0;
  const retryAt = Date.now() + delay;
  let busy = false;
  let button;
  function draw() {
    const waiting = Date.now() < retryAt;
    container.innerHTML = authShell(`
      <div class="auth-recovery">
      <h1 class="auth-heading">${escapeHtml(t('auth.recovery.title'))}</h1>
      <p class="auth-subtitle">${escapeHtml(t('auth.recovery.subtitle'))}</p>
      <div class="auth-error" role="alert" aria-atomic="true">${escapeHtml(error.message || t('errors.GENERIC'))}</div>
      ${waiting ? `<p class="auth-hint" role="status" data-retry-wait>${escapeHtml(t('auth.recovery.waiting'))}</p>` : ''}
      <button type="button" class="auth-submit" data-session-retry data-auth-focus="retry" ${waiting || busy ? 'disabled' : ''}>
        ${escapeHtml(t(busy ? 'common.loading' : 'common.retry'))}
      </button>
      </div>
    `, { busy });
    bindLangSelect(container, draw);
    button = container.querySelector('[data-session-retry]');
    button.addEventListener('click', async () => {
      if (busy || Date.now() < retryAt) return;
      busy = true;
      draw();
      try {
        await retry();
      } catch {
        busy = false;
        draw();
      }
    });
  }
  draw();
  if (delay > 0) setTimeout(() => {
    if (button.isConnected && !busy) {
      button.disabled = false;
      container.querySelector('[data-retry-wait]')?.remove();
    }
  }, delay);
}
